import type { JSX } from 'react';

export function TablaVacia({ mensaje }: { mensaje: string }): JSX.Element {
  return <p className="py-3 text-sm text-muted-foreground">{mensaje}</p>;
}
